import axios from "axios";

// v1.13.2: the API is same-origin by contract — the host routes /api to the backend in every
// environment, so the base is RELATIVE. No build-time hostname, no cross-origin call, no CORS in play.
export const API_BASE = "/api";
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

// §5 v1.12.6.8: no admin request may ever carry the literal "undefined"/"null" as a path id —
// a component holding a missing id must disable its control, never fire the request.
api.interceptors.request.use((config) => {
  if (/\/(undefined|null)([/?#]|$)/.test(config.url || "")) {
    return Promise.reject(new Error(`Blocked request with a missing id in the path: ${config.url}`));
  }
  return config;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || "Something went wrong";
}

export async function uploadEcoChunked(file, onProgress) {
  const { data: init } = await api.post("/admin/uploads/init", { filename: file.name, kind: "eco", purpose: "eco_extract" });
  const size = init.chunk_size;
  const total = Math.ceil(file.size / size);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("index", i);
    fd.append("chunk", file.slice(i * size, (i + 1) * size));
    await api.post(`/admin/uploads/${init.upload_id}/chunk`, fd);
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }
  const { data } = await api.post(`/admin/uploads/${init.upload_id}/complete`);
  return data;
}

export async function uploadSourceChunked(certId, file, kind, onProgress) {
  const { data: init } = await api.post("/admin/uploads/init", { cert_id: certId, filename: file.name, kind });
  const size = init.chunk_size;
  const total = Math.ceil(file.size / size);
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("index", i);
    fd.append("chunk", file.slice(i * size, (i + 1) * size));
    await api.post(`/admin/uploads/${init.upload_id}/chunk`, fd);
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }
  const { data } = await api.post(`/admin/uploads/${init.upload_id}/complete`);
  return data;
}
